'use client'
import {
  Card,
  Col,
  LoadMoreSection,
  Row,
  Separator,
  Skeleton,
} from '@repo/ui/components'
import { Fragment } from 'react'
import { BalanceProjectTransferItem } from './balance-project.transfer.item'
import { useListUserAssetTransfers } from '@repo/services'
import { BalanceProjectTransferEmptyState } from './balance-project.transfer.empty-state'

export const BalanceProjectTransferHistory = ({
  projectId,
}: {
  projectId?: string
}) => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useListUserAssetTransfers({
      skip: 0,
      limit: 10,
      ...(projectId ? { currency: projectId } : {}),
    })
  const transfers =
    data?.pages?.flatMap((page) => page.data?.transfers || []) || []

  return (
    <Row className='min-h-screen items-start mb-8xl'>
      <Card className='flex-1' withoutBorder>
        <Col>
          {isLoading && (
            <div className='space-y-2'>
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
            </div>
          )}
          {transfers?.map((transfer, index) => (
            <Fragment key={transfer.id}>
              {index !== 0 && <Separator />}
              <BalanceProjectTransferItem
                showCurrency={!projectId}
                data={transfer}
                projectId={projectId}
              />
            </Fragment>
          ))}
          {transfers?.length === 0 && !isLoading && (
            <BalanceProjectTransferEmptyState />
          )}
          <LoadMoreSection
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            isLoading={isLoading}
          />
        </Col>
      </Card>
    </Row>
  )
}
